export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_FR_RGB_wht_100217.0641e511.svg";